var React = require('react');

function Mic (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"SoundVideoMicVector","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"id":"ZeplinVector","fillRule":"nonzero","x":"0","y":"0","width":"24","height":"24","key":0}),React.createElement("path",{"d":"M12,14 C13.66,14 14.99,12.66 14.99,11 L15,5 C15,3.5 14,3 13,3 C12.3608784,3 11.5998197,3 11,3 C10,3 9,3.5 9,5 L9,11 C9,12.66 10.34,14 12,14 Z M17.3,11 C17.3,14 14.76,16.1 12,16.1 C9.24,16.1 6.7,14 6.7,11 L5,11 C5,14.41 7.72,17.23 11,17.72 L11,21 L13,21 L13,17.72 C16.28,17.24 19,14.42 19,11 L17.3,11 Z","id":"Shape","fill":"#ffffff","key":1})]));
}

Mic.defaultProps = {"role":"img","aria-labelledby":"Microphone","aria-describedby":"Microphone","aria-label":"Microphone","className":"mic-icon","width":"24px","height":"24px","viewBox":"0 0 24 24","id":"Microphone","version":"1.1"};

module.exports = Mic;

Mic.default = Mic;
